import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AppBar, Tab, Tabs } from "@material-ui/core";
import TabPanel from "../component/TabPanel";
import DailyTaskRewards from "../component/table/DailyTaskRewards";
import GiftBoxLevels from "./GiftBoxLevels";

const VibePass = () => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Vibe Pass</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">Vibe Pass</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <AppBar position="static">
        <Tabs value={tabValue} onChange={(_, value) => setTabValue(value)}
          aria-label="Vibe Pass tabs" indicatorColor="primary">
          <Tab label="Daily Tasks" id="vibe-pass-tab-0" aria-controls="vibe-pass-panel-0" />
          <Tab label="Gift Box Levels" id="vibe-pass-tab-1" aria-controls="vibe-pass-panel-1" />
        </Tabs>
      </AppBar>
      <TabPanel value={tabValue} index={0} id="vibe-pass-panel-0" aria-labelledby="vibe-pass-tab-0">
        <DailyTaskRewards />
      </TabPanel>
      <TabPanel value={tabValue} index={1} id="vibe-pass-panel-1" aria-labelledby="vibe-pass-tab-1">
        <GiftBoxLevels />
      </TabPanel>
    </>
  );
};

export default VibePass;
